import { Component, OnInit } from '@angular/core';

import { ClusterService } from '@fry/lib/organisations/cluster.service';


@Component({
    selector: 'eas-translation-selector',
    templateUrl: './translation-selector.component.html',
    styleUrls: ['./translation-selector.component.css'],
    standalone: false
})
export class TranslationSelectorComponent implements OnInit {
  translationLanguages: any;

  constructor(
    private cluster: ClusterService
  ) {

  }

  ngOnInit() {
    const organisationLanguages = this.cluster.getCurrentOrganisation().availableLanguages;
    this.translationLanguages = organisationLanguages === null
      ? []
      : organisationLanguages.filter(
        organisationLanguage => organisationLanguage['is_default'] !== true
      ).map(
        organisationLanguage => ({
          languageCode: organisationLanguage['language_code'],
          languageName: organisationLanguage['language_name']
        })
      );
  }
}
